import { PostFinanceAddinfoAccountsApi } from "@/features/accounts/finance/services/post-addinfo-accounts-api";
import { PostFinanceAddinfoAccountsRequestModel } from "@/features/accounts/finance/services/post-addinfo-accounts-model";

/// 銀行口座登録処理
export class PostFinanceAddinfoAccountsService {
  private postFinanceAddinfoAccountsApi = new PostFinanceAddinfoAccountsApi();

  /**
   * 銀行口座登録API実行
   */
  public async postFinanceAddinfoAccounts(param: PostFinanceAddinfoAccountsRequestModel) {
    return await this.postFinanceAddinfoAccountsApi.postFinanceAddinfoAccounts(param);
  }
}
